import React, { useEffect, useState } from "react";
import { BASE_API_URL } from "../../services/baseServices";
import Swal from 'sweetalert2';
import axios from "axios";
import { Select } from 'antd';
import { addOrganization } from "../../services/organizationServices";

export default function AddOrganization() {

    const { Option } = Select;
    const [sessionUserData, setSessionUserData] = useState({});
    const [image, setImage] = useState(null);
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const [categoriesData, setCategoriesData] = useState([]);
    const [imagePreview, setImagePreview] = useState(null);
    const [submitLoading, setSubmitLoading] = useState(false);

    const [formData, setFormData] = useState({
        OrgId: '',
        OrgName: '',
        Address: '',
        PhoneNo: '',
        EmailId: '',
        IsActive: '1',
        CreatedBy: sessionUserData?.Id,
        ImageUrl: '',
    });

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setSessionUserData(userData);
        } else {
            console.log("data not available in session");
        }
    }, []);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setImage(file);

        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        } else {
            setImagePreview(null);
        }
    };

    const handleRemoveImage = () => {
        setImage(null);
        setImagePreview(null);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitLoading(true);

        const data = new FormData();

        for (const key in formData) {
            if (key !== 'ImageUrl') {
                data.append(key, formData[key]);
            }
        }

        if (image) {
            data.append('ImageUrl', image);
        }

        for (let pair of data.entries()) {
            console.log(`${pair[0]}: ${pair[1]}`);
        }

        try {
            const response = await addOrganization(data);
            const result = response.data;

            if (result.ResultData.Status === 'Success') {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'Organization added successfully!',
                }).then(() => {
                    window.location.reload();
                });
            } else {
                throw new Error(result.output.Message || 'Unknown error');
            }
        } catch (error) {
            console.error('Error uploading organization:', error);
            Swal.fire({
                icon: 'error',
                title: 'Failed',
                text: 'Failed to add organization.',
            });
        } finally {
            setSubmitLoading(false);
        }
    }

    return (
        <div
            className="offcanvas offcanvas-end"
            tabIndex="-1"
            id="offcanvasRightAdd"
            aria-labelledby="offcanvasRightLabel"
            style={{ minWidth: "45%", maxWidth: "45%" }}
        >
            <form autoComplete="off" onSubmit={handleSubmit}>
                <div className="offcanvas-header d-flex justify-content-between align-items-center">
                    <h5 id="offcanvasRightLabel" className="mb-0">Add Organization</h5>
                    <div className="d-flex align-items-center">
                        <button
                            className="btn btn-primary p-2 rounded w-full me-2"
                            type="submit"
                            disabled={submitLoading}
                        >
                            {submitLoading ? 'Submitting...' : 'Submit'}
                        </button>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        ></button>
                    </div>
                </div>
                <div
                    className="offcanvas-body"
                    style={{
                        minHeight: '33rem',
                        overflowY: 'auto',
                        paddingBottom: '2rem',
                    }}
                >
                    <div className="row">
                        <div className="col-12 mb-2 col-md-6">
                            <label className="form-label">Name <span className="text-danger">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                name="OrgName"
                                placeholder="Enter Organization Name"
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="col-12 mb-2 col-md-6">
                            <label className="form-label">OrgId <span className="text-danger">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                name="OrgId"
                                placeholder="Enter Organization ode"
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="col-12 mb-2 col-md-6">
                            <label className="form-label">Phone No <span className="text-danger">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                name="PhoneNo"
                                placeholder="Enter Phone No"
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="col-12 mb-2 col-md-6">
                            <label className="form-label">EmailId <span className="text-danger">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                name="EmailId"
                                placeholder="Enter Email Id"
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="col-12 mb-2 col-md-6">
                            <label className="form-label">Logo <span className="text-danger">*</span></label>
                            <input
                                type="file"
                                className="form-control"
                                name="ImageUrl"
                                placeholder="Enter Description"
                                accept="image/*"
                                onChange={handleImageChange}
                                required
                            />
                        </div>
                        <div className="col-12 mb-2">
                            <label className="form-label">Address <span className="text-danger">*</span></label>
                            <textarea
                                className="form-control"
                                placeholder="Enter address"
                                name="Address"
                                onChange={handleChange}
                                required
                            ></textarea>
                        </div>
                        {imagePreview && (
                            <div className="col-12 my-4 position-relative" style={{ width: "280px", height: "280px" }}>
                                <label className="form-label">Image Preview</label>
                                <div className="position-relative" style={{ width: "100%", height: "100%" }}>
                                    <img
                                        src={imagePreview}
                                        alt="Preview"
                                        className="rounded border"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            borderRadius: "0.5rem"
                                        }}
                                    />
                                    <button
                                        type="button"
                                        onClick={handleRemoveImage}
                                        className="btn btn-sm text-danger fw-bold position-absolute"
                                        style={{
                                            top: "0",
                                            right: "0",
                                            zIndex: "10",
                                            background: "white",
                                            border: "none",
                                            borderRadius: "0 0 0 0.5rem",
                                            padding: "0.25rem 0.5rem",
                                            cursor: "pointer",
                                        }}
                                        aria-label="Remove image"
                                    >
                                        X
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </form>
        </div>
    );
}
